/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum MedicalHistoryCategory {
    CONDITION = 'Condition',
    GENERAL_HEALTH = 'GeneralHealth',
    WOMENS_HEALTH = 'WomensHealth',
    ALLERGY = 'Allergy',
    MEDICATION = 'Medication',
    ANAESTHETIC_HISTORY = 'AnaestheticHistory',
    LIFESTYLE = 'Lifestyle',
    SCREENING = 'Screening',
    NOTE = 'Note',
}
